export var words = ["Zero", "One", "Two", "Three", "Four", "Five"];
export var messageCreater = function (count, section, isZero) {
    var msg = "";
    if (count === 0 && !isZero) {
        msg = "No stocks are at ".concat(section, " today");
    }
    else {
        msg = "".concat(isZero ? "" : "only", " ").concat(words[count], " stocks are at ").concat(section);
    }
    return msg;
};
